module.exports = __webpack_public_path__ + "img/AusDemLot.73efa091.jpg";